export const blogPosts = [
 {
  id: 1,
  title: "Learning Management System (LMS) — Java Backend Development",
  excerpt: "Designed and developed a scalable Java Spring Boot backend for a Learning Management System, featuring secure REST APIs for authentication, course management, student enrollment, assignments, quizzes, and progress tracking.",
  date: "July 7, 2026",
  author: "Sandeep Konda",
  category: "Java Backend",
  path: "/blog/ApiSynIQ",
  readTime: 8,
  views: 1247,
  likes: 89,
  tags: [
    "Java",
    "Spring Boot",
    "Spring Security",
    "JWT",
    "Hibernate",
    "JPA",
    "REST API",
    "MySQL",
    "LMS"
  ]
},
  {
    id: 2,
    title: "Deploying Java Microservices on Kubernetes",
    excerpt: "A comprehensive guide to containerizing and deploying Spring Boot applications on Kubernetes with production-ready configurations.",
    date: "June 1, 2026",
    author: "Sandeep Konda",
    category: "Kubernetes",
    path: "/blog/kubernetes-java",
    readTime: 12,
    views: 3421,
    likes: 234,
    tags: ["Kubernetes", "Java", "Spring Boot", "Docker", "EKS", "Helm", "Istio", "cert-manager", "Kafka", "Redis"]
  },
  {
    id: 3,
    title: "Production CI/CD Pipeline: From Git Commit to Kubernetes",
    excerpt: "Build a complete CI/CD pipeline that automatically builds, tests, and deploys Java applications to Kubernetes.",
    date: "May 28, 2026",
    author: "Sandeep Konda",
    category: "DevOps",
    path: "/blog/devops-pipeline",
    readTime: 15,
    views: 2856,
    likes: 178,
    tags: ["Jenkins", "GitHub Actions", "Kubernetes", "Terraform", "ArgoCD", "Docker"]
  },
  {
    id: 4,
    title: "Building Production-Ready Microservices with Spring Boot",
    excerpt: "Practical guide to building scalable, resilient microservices using Spring Boot, Spring Cloud, and industry best practices.",
    date: "June 1, 2026",
    author: "Sandeep Konda",
    category: "Java Backend",
    path: "/blog/microservices-java",
    readTime: 12,
    views: 1987,
    likes: 145,
    tags: ["Java", "Spring Boot", "Microservices", "Docker", "Kafka", "Redis"]
  },
  {
    id: 5,
    title: "Zufeto – Scalable E-Commerce Platform on AWS",
    excerpt: "A cloud-native e-commerce platform designed to support customers, vendors, and administrators through dedicated web applications and backend services on AWS.",
    date: "June 5, 2026",
    author: "Sandeep Konda",
    category: "Cloud Architecture",
    path: "/blog/zufeto",
    readTime: 18,
    views: 892,
    likes: 67,
    tags: ["AWS", "ECS", "Terraform", "Spring Boot", "React", "PostgreSQL", "S3", "CloudFront", "Route53", "Docker", "GitHub Actions"]
  }
];